<template>
    <div class="pos-r" v-bind:style="{width: width, height:height}">
        <div v-show="status==1"
             class="textC ys-info-color"
             v-bind:style="{width: width, height:height,lineHeight:height}">
            <div class="d-i-b verticalM">
                <!--<p style="line-height:1"><i class="ys-icon icon-chart-no-data"-->
                                            <!--style="margin-left:6px;color:rgba(154,188,238,0.25);font-size: 60px;"></i>-->
                <!--</p>-->
                <p v-if="no == '1'" v-bind:style="{width: width, height:height,lineHeight:height, color: '#787878'}">暂无数据</p>
                <p v-if="no == '2'"><img style="width: 60%;vertical-align: middle;max-width: 200px;opacity:0.5; " src="../assets/img/nochart.png" alt=""></p>
            </div>
            <span style="display:none;">{{status}}</span>
        </div>
        <div v-show="status==2">
            <div v-bind:style="{width: width,height:height}">
                <div :id="'line-chart-'+id"
                     v-bind:style="{width: width,height:height}"
                     v-on:resize="handleResize($event)">
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped></style>
<script>
    export default {
        name: 'line-chart',
        props: {
            id: {
                default: 0
            },
            name: {
                default: ""
            },
            width: {
                default: "100%"
            },
            height: {
                default: "200px"
            },
            x: {
                default: ""
            },
            y: {
                default: []
            },
            unit: {
                default: ""
            },
            tipname: {
                default: ""
            },
            no:{
                default: '1'
            },
            markArea: {
                default: ""
            },
            dateUnit: {
                default: ""
            },
            colorObj:{
                type: Object,
                default:()=>{
                    return {}
                }
            }
        },
        computed: {
            status: function () {
                if (this.x.length > 0) {
                    this.$nextTick(()=>{
                        this.initChart();
                    });
                    return 2
                } else {
                    return 1
                }
            },
        },
        data(){
            return {
                symbol:['circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'],
                color: {
                    Ta:'#ffcf39',
                    Tb:'#007b24',
                    Tc:'#ff695f',
                    Tn:'#00a8f8',
                    To:'#00727b',
                    电气温度Ta:'#ffcf39',
                    电气温度Tb:'#007b24',
                    电气温度Tc:'#ff695f',
                    电气温度Tn:'#00a8f8',
                    电气温度To:'#00727b',
                    温度Ta: this.$colorObj[10101],
                    温度Tb:this.$colorObj[10102],
                    温度Tc: this.$colorObj[10103],
                    温度Tn: this.$colorObj[10104],
                    温度To: this.$colorObj[10105],
                    相电压Uan: this.$colorObj[10304],
                    相电压Ubn:  this.$colorObj[10305],
                    相电压Ucn:  this.$colorObj[10306],
                    今日: '#00ff43',
                    昨日: '#f700b0',
                    yesterday:'#f700b0',
                    today:'#00ff43',
                    功率因数:  this.$colorObj[10800],
                    电流Ia: this.$colorObj[10201],
                    电流Ib: this.$colorObj[10202],
                    电流Ic: this.$colorObj[10203],
                    预警: '#97b551',
                    隐患: '#2fc7c9',
                    故障: '#58c9b9',
                    报警: '#ffb980',
                    负风压2:'#ffcf39',
                    负风压1:'#007b24',
                    正风压1:'#ff695f',
                    正风压2:'#00a8f8',
                    值:'#2d8cf0'
                }
                // color: [
                //     ['#ffcf39','#007b24','#ff695f','#00a8f8','#00727b']
                // ]
            }
        },
        methods: {
            initChart() {
                if(!this.dateUnit){ //默认只显示时分秒，需要截取
                    for(let i = 0;i < this.x.length; i++){
                        if(this.x[i].split(' ').length > 1){
                            this.x[i] = this.x[i].split(' ')[1];
                        }
                    }
                }
                
                let self = this;
                let repeat = setInterval(function () {
                    if (document.getElementById('line-chart-' + self.id)) {
                        self.setChart();
                        window.addEventListener('resize', self.handleResize)
                        var EleResize = {
                            _handleResize: function (e) {
                                var ele = e.target || e.srcElement;
                                var trigger = ele.__resizeTrigger__;
                                if (trigger) {
                                    var handlers = trigger.__z_resizeListeners;
                                    if (handlers) {
                                        var size = handlers.length;
                                        for (var i = 0; i < size; i++) {
                                            var h = handlers[i];
                                            var handler = h.handler;
                                            var context = h.context;
                                            handler.apply(context, [e]);
                                        }
                                    }
                                }
                            },
                            _removeHandler: function (ele, handler, context) {
                                var handlers = ele.__z_resizeListeners;
                                if (handlers) {
                                    var size = handlers.length;
                                    for (var i = 0; i < size; i++) {
                                        var h = handlers[i];
                                        if (h.handler === handler && h.context === context) {
                                            handlers.splice(i, 1);
                                            return;
                                        }
                                    }
                                }
                            },
                            _createResizeTrigger: function (ele) {
                                var obj = document.createElement('object');
                                obj.setAttribute('style',
                                    'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden;opacity: 0; pointer-events: none; z-index: -1;');
                                obj.onload = EleResize._handleObjectLoad;
                                obj.type = 'text/html';
                                ele.appendChild(obj);
                                obj.data = 'about:blank';
                                return obj;
                            },
                            _handleObjectLoad: function (evt) {
                                this.contentDocument.defaultView.__resizeTrigger__ = this.__resizeElement__;
                                this.contentDocument.defaultView.addEventListener('resize', EleResize._handleResize);
                            }
                        };
                        if (document.attachEvent) {//ie9-10
                            EleResize.on = function (ele, handler, context) {
                                var handlers = ele.__z_resizeListeners;
                                if (!handlers) {
                                    handlers = [];
                                    ele.__z_resizeListeners = handlers;
                                    ele.__resizeTrigger__ = ele;
                                    ele.attachEvent('onresize', EleResize._handleResize);
                                }
                                handlers.push({
                                    handler: handler,
                                    context: context
                                });
                            };
                            EleResize.off = function (ele, handler, context) {
                                var handlers = ele.__z_resizeListeners;
                                if (handlers) {
                                    EleResize._removeHandler(ele, handler, context);
                                    if (handlers.length === 0) {
                                        ele.detachEvent('onresize', EleResize._handleResize);
                                        delete  ele.__z_resizeListeners;
                                    }
                                }
                            }
                        } else {
                            EleResize.on = function (ele, handler, context) {
                                var handlers = ele.__z_resizeListeners;
                                if (!handlers) {
                                    handlers = [];
                                    ele.__z_resizeListeners = handlers;
                                    if (getComputedStyle(ele, null).position === 'static') {
                                        ele.style.position = 'relative';
                                    }
                                    var obj = EleResize._createResizeTrigger(ele);
                                    ele.__resizeTrigger__ = obj;
                                    obj.__resizeElement__ = ele;
                                }
                                handlers.push({
                                    handler: handler,
                                    context: context
                                });
                            };
                            EleResize.off = function (ele, handler, context) {
                                var handlers = ele.__z_resizeListeners;
                                if (handlers) {
                                    EleResize._removeHandler(ele, handler, context);
                                    if (handlers.length === 0) {
                                        var trigger = ele.__resizeTrigger__;
                                        if (trigger) {
                                            trigger.contentDocument.defaultView.removeEventListener('resize', EleResize._handleResize);
                                            ele.removeChild(trigger);
                                            delete ele.__resizeTrigger__;
                                        }
                                        delete  ele.__z_resizeListeners;
                                    }
                                }
                            }
                        }
                        var resizeDiv = document.getElementById('line-chart-' + self.id);
                        EleResize.on(resizeDiv, function () {
                            self.handleResize()
                        });
                        clearInterval(repeat)
                    }
                }, 300)
            },
            setChart() {
                let self = this, series = [];
                self.chart = this.$echarts.init(document.getElementById('line-chart-' + this.id));
                if(this.markArea.data){ //如果有显示灰色掉线区域则显示
                    this.markArea.data.forEach(function(value) {
                        value[0].itemStyle = { color:'rgba(0,0,0,0.1)'};
                    });
                }
                for (let value in this.y) {
                    series.push({
                        name: value,
                        itemStyle: {
                            color:( value == 'today' || value == 'yesterday' ) ? '' : this.$colorObj[this.colorObj[value]]
                        },
                        type: 'line',
                        data: this.y[value],
                        showSymbol:false,
                        // step: 'middle',
                        symbolSize: 5,
                        markArea: this.markArea,
                    })
                }
                this.option = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            lineStyle: {
                                color: "#74d9ff",
                                opacity: 0.2
                            },
                        },
                        formatter: function (params) {
                            //console.log(params)
                            let str = params[0].name
                            for (var i = 0; i < params.length; i++) {
                                if (self.unit == "band") {
                                    str += "<br/>" + params[i].seriesName + ":" + self.changeUnit(params[i].value)
                                } else if (self.unit == "percent") {
                                    str += "<br/>" + params[i].seriesName + ":" + params[i].value + "%"
                                } else if (self.unit == "wan") {
                                    str += "<br/>" + params[i].seriesName + ":" + self.changeWanUnit(params[i].value)
                                } else {
                                    if (self.tipname == "") {
                                        str += "<br/>" + params[i].seriesName + ":" + params[i].value
                                    } else {
                                        str += "<br/>" + self.tipname + ":" + params[i].value
                                    }
                                }
                            }
                            return str
                        }
                    },
                    grid: {
                        top: 50,
                        bottom: 20,
                        left: 60,
                        right: 60,
                        containLabel: true
                    },
                    color: this.$colorObj.colorGroup,
                    legend: {
                        x: 'center',
                        top: 0,
                        data: self.name,
                        textStyle: {
                            color: "#74d9ff",
                        }
                    },
                    calculable: true,
                    xAxis: [{
                        type: 'category',
                        data: self.x,
                        boundaryGap: false,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#122856",
                            }
                        },
                        axisTick: {
                            show: false,
                        },
                        axisLabel: {textStyle: {color: "#CCCCCC"}}
                    }],
                    yAxis: [{
                        type: 'value',
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#122856",
                            }
                        },
                        axisTick: {
                            show: false,
                        },
                        splitNumber: 5,
                        axisLabel: {
                            textStyle: {color: "#CCCCCC"},
                            formatter: function (value) {
                                if (self.unit == "band") {
                                    return self.changeUnit(value)
                                } else if (self.unit == "percent") {
                                    return value + "%"
                                } else if (self.unit == "wan") {
                                    if (value < 10000) {
                                        return value
                                    } else if (value >= 10000 && value < 10000 * 10000) {
                                        value = (value / 10000).toFixed(2);
                                        return value + "万"
                                    } else {
                                        value = (value / (10000 * 10000)).toFixed(2);
                                        return value + "亿"
                                    }
                                } else {
                                    return value
                                }
                            },
                        },//y轴坐标的字颜色
                        splitLine: {
                            lineStyle: {
                                color: "#122856",
                            }
                        }
                    }],
                    series: series
                };
                self.chart.clear();
                setTimeout(() => {
                    self.chart.setOption(self.option);
                }, 0);
            },
            changeUnit(val) {
                if (val < 1024) {
                    return val + "b"
                } else if (val >= 1024 && val < 1024 * 1024) {
                    val = (val / 1024).toFixed(1);
                    return val + "Kb"
                } else if (val >= 1024 * 1024 && val < 1024 * 1024 * 1024) {
                    val = (val / (1024 * 1024)).toFixed(1);
                    return val + "Mb"
                } else if (val >= 1024 * 1024 * 1024) {
                    val = (val / (1024 * 1024 * 1024)).toFixed(1);
                    return val + "Gb"
                }
            },
            changeWanUnit(val) {
                if (val < 10000) {
                    return val
                } else if (val >= 10000 && val < 10000 * 10000) {
                    val = (val / 10000).toFixed(2);
                    return val + "万"
                } else {
                    val = (val / (10000 * 10000)).toFixed(2);
                    return val + "亿"
                }
            },
            handleResize() {
                this.chart.resize();
            },
            hexToRgba(hex, al) {
                var hexColor = /^#/.test(hex) ? hex.slice(1) : hex, alp = hex === 'transparent' ? 0 : Math.ceil(al), r,
                    g, b;
                hexColor = /^[0-9a-f]{3}|[0-9a-f]{6}$/i.test(hexColor) ? hexColor : 'fffff';
                if (hexColor.length === 3) {
                    hexColor = hexColor.replace(/(\w)(\w)(\w)/gi, '$1$1$2$2$3$3');
                }
                r = hexColor.slice(0, 2);
                g = hexColor.slice(2, 4);
                b = hexColor.slice(4, 6);
                r = parseInt(r, 16);
                g = parseInt(g, 16);
                b = parseInt(b, 16);
                return {
                    hex: '#' + hexColor,
                    alpha: alp,
                    rgba: 'rgba(' + r + ', ' + g + ', ' + b + ', ' + (alp / 100).toFixed(2) + ')'
                };
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/line.vue